export default "__VITE_ASSET__ByoqLv0O__"